import { MenuItemPriceType } from '~/enums'
import { usePresentationTranslator } from '~/composables/usePresentationTranslator'

interface PriceTypeCopy {
  description: string
  label: string
  priceField: string
  unit: string
}

export const useMenuItemPriceTypeCopy = () => {
  const t = usePresentationTranslator()

  const copyByType: Record<MenuItemPriceType, () => PriceTypeCopy> = {
    [MenuItemPriceType.EACH]: () => ({
      description: t('dashboard.menuItemPriceTypes.each.description'),
      label: t('dashboard.menuItemPriceTypes.each.label'),
      priceField: t('dashboard.menuItemPriceTypes.each.priceField'),
      unit: t('dashboard.menuItemPriceTypes.each.unit')
    }),
    [MenuItemPriceType.GROUP_TRAY]: () => ({
      description: t('dashboard.menuItemPriceTypes.group_tray.description'),
      label: t('dashboard.menuItemPriceTypes.group_tray.label'),
      priceField: t('dashboard.menuItemPriceTypes.group_tray.priceField'),
      unit: t('dashboard.menuItemPriceTypes.group_tray.unit')
    }),
    [MenuItemPriceType.PER_PERSON]: () => ({
      description: t('dashboard.menuItemPriceTypes.per_person.description'),
      label: t('dashboard.menuItemPriceTypes.per_person.label'),
      priceField: t('dashboard.menuItemPriceTypes.per_person.priceField'),
      unit: t('dashboard.menuItemPriceTypes.per_person.unit')
    })
  }

  const copyField =
    (field: keyof PriceTypeCopy) =>
    (value: MenuItemPriceType): string =>
      copyByType[value]()[field]

  const priceWithUnit = (formattedPrice: string, value: MenuItemPriceType): string => {
    return value === MenuItemPriceType.PER_PERSON
      ? t('dashboard.menuItemPriceTypes.per_person.priceWithUnit', { price: formattedPrice })
      : formattedPrice
  }

  return {
    description: copyField('description'),
    label: copyField('label'),
    priceFieldLabel: copyField('priceField'),
    priceWithUnit,
    unitLabel: copyField('unit')
  }
}
